import React from 'react';
import 'yuki-createjs';
import { connect } from 'react-redux';
import Char from '../shared/Char';
import TraceOnBtn from '../shared/TraceOnBtn';
import TraceOffBtn from '../shared/TraceOffBtn';
import GuidelinesOnBtn from '../shared/GuidelinesOnBtn';
import GuidelinesOffBtn from '../shared/GuidelinesOffBtn';
import { setSpacing, setWordBounds } from '../../../utils/utils';

export class WordWatch extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            array: [],
            isPlaying: true,
            guidelinesShown: true
        };

        createjs.Ticker.on('tick', this.tick, this);
        createjs.Ticker.framerate = 30;
    }
    load() {
        if (this.state.word === 'didnt') {
            this.state.letters = ['d','i','d','n',"'",'t'];
        } else if (this.state.word === 'sunday') {
            this.state.letters = ['S','u','n','d','a','y'];
        } else {
            this.state.letters = [...this.state.word];
        }

        this.state.total = this.state.letters.length;

        this.state.loader = new createjs.LoadQueue(true);
        this.state.loader.on('complete', this.create, this);

        this.state.manifest = [];
        
        for (let i = 0; i < this.state.total; i++) {
            let letterCase = 'lc';

            if (this.state.letters[i] === 'S') {
                letterCase = 'uc';
            }

            this.state.manifest.push({
                src: 'images/sections/' + letterCase + '/chars/watch/' + this.state.letters[i] + '.json', 
                id: 'word-letter-spritesheet-' + i,
                type: 'spritesheet'
            });
        }

        while (this.state.manifest.length > 0) {
            this.state.loader.loadFile(this.state.manifest.shift());
        }
    }
    create() {
        let _this = this;

        for (var i = 0; i < this.state.total; i++) {
            let cvs = document.getElementById('lc-watch-cvs-' + i),
                btn = $('.char-btn', '#word-watch');

            this.state.array[i] = new Object();
            this.state.array[i].canvas = cvs;
            this.state.array[i].stage = new createjs.Stage(this.state.array[i].canvas);
            this.state.array[i].anim = new createjs.Sprite(this.state.loader.getResult('word-letter-spritesheet-' + i));
            this.state.array[i].anim.id = i;

            this.state.array[i].stage.addChild(this.state.array[i].anim);
            this.state.array[i].anim.on('animationend', this.end, this);
        }

        if (this.state.isPlaying) {
            this.play();
        }

        $(window).on('resize.word-watch', function() {
            _this.resize();
        });

        this.resize();
    }
    end(e) {
        e.target.stop();

        if (e.target.id < (this.state.total - 1)) {
            this.state.array[e.target.id + 1].anim.gotoAndPlay('active');
        } else {
            for (var i = 0; i < this.state.total; i++) {
                this.state.array[i].anim.gotoAndStop('inactive');
            }
            this.state.array[0].anim.gotoAndPlay('active');
        }
    }
    tick() {
        if (this.state.array.length) {
            for (var i = 0; i < this.state.total; i++) {
                if (this.state.array[i].stage !== undefined) {
                    this.state.array[i].stage.update();
                }
            }
        }
    }
    pos() {
        const holder = $('.holder-inner', '#word-watch'),
            holderBaseW = 447,
            holderBaseH = 104;
        let char = $('.char-holder', '#word-watch'),
            holderW = holder.width(),
            holderH = holder.height(),
            holderPercW = holderW / 100,
            holderPercH = holderH / 100,
            wordW = (this.state.bounds[1] + 3.25) * 0.8,
            wordL = (holderBaseW * 0.5) - (wordW * 0.5),
            wordLPerc = (wordL/holderBaseW) * 100,
            xPos,
            boundsL;

        for (let i = 0; i < this.state.total; i++) {

            boundsL = wordL + (this.state.bounds[2][i]*0.8);
            xPos = (holderPercW * ((boundsL/holderBaseW) * 100));

            char.eq(i).css('left', xPos + 'px');
        }
    }
    resize() {
        const parent = $('.char-holder'),
            curr = $('.lc-watch-cvs');
        let parentW = parent.width(),
            parentH = parent.height(),
            currW = curr.width(),
            currH = curr.height(),
            scale = parentW / currW;

        curr.attr('height', $('#word-watch').height() - $('.holder', '#word-watch').position().top);
        
        for (var i = 0; i < this.state.total; i++) {
            this.state.array[i].stage.scaleX = scale;
            this.state.array[i].stage.scaleY = scale;
        }

        this.pos();
    }
    play() {
        this.stop();
        if (this.state.array.length) {
            
            this.state.array[0].anim.gotoAndPlay('active');
        }
        this.setState({ isPlaying: true });
    }
    stop() {
        if (this.state.array.length) {
            for (var i = 0; i < this.state.total; i++) {
                this.state.array[i].anim.gotoAndStop('active');
            }
        }
        this.setState({ isPlaying: false });
    }
    guidelinesShow() {
        $('.guidelines', '#word-watch').show();
        this.setState({ guidelinesShown: true });
    }
    guidelinesHide() {
        $('.guidelines', '#word-watch').hide();
        this.setState({ guidelinesShown: false });
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.word) {
            this.setState({ isPlaying: true });
            this.guidelinesShow();
            this.state.word = nextProps.word;
            this.state.bounds = setWordBounds(nextProps.word);
            this.load();
        }
    }
    componentWillUnmount() {
        $(window).off('resize.word-watch');
    }
    render() {
        let char = '';
        if (this.props.word) {
            char = 
                [...Array(this.state.total)].map((label, index) => {
                    return (
                        <Char key={index} id={index} charType="lc" animType="watch" />
                    );
                });
        }
        return (
            <div id="word-watch" className="panel">
                <div className="title"></div>
                <div className="panel-arrow-d"></div>
                <div className="guidelines-txt"></div>
                <GuidelinesOffBtn onClick={this.guidelinesHide.bind(this)} selected={!this.state.guidelinesShown} />
                <GuidelinesOnBtn onClick={this.guidelinesShow.bind(this)} selected={this.state.guidelinesShown} />
                <div className="trace-txt"></div>
                <TraceOffBtn onClick={this.stop.bind(this)} selected={!this.state.isPlaying} />
                <TraceOnBtn onClick={this.play.bind(this)} selected={this.state.isPlaying} />
                <div className="holder">
                    <div className="holder-inner">
                        {char}
                    </div>
                    <div className="guidelines"></div>
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state) => ({
    word: state.word.word
})

export default connect(mapStateToProps, undefined)(WordWatch);


// WEBPACK FOOTER //
// ./src/components/sections/words/WordWatch.js